module.exports = __webpack_public_path__ + "img/18.48cc056c.jpg";